
  export const FREQUENTQUESTIONS_RECEIVED = "FREQUENTQUESTIONS_RECEIVED";
  export const SET_FREQUENTQUESTION = "SET_FREQUENTQUESTION";
  export const CREATE_FREQUENTQUESTION = "CREATE_FREQUENTQUESTION";
  export const SET_PROPERTY_FREQUENTQUESTION = "SET_PROPERTY_FREQUENTQUESTION";
  